import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store';

import { ADMIN, CANDIDATE, MANAGER } from '@/common/constants/userTypes';

// Layouts
import AuthLayout from '@/layouts/AuthLayout';
import DashboardLayout from '@/layouts/DashboardLayout';

// Pages
import Home from '@/views/Home';
import NoAccess from '@/views/NoAccess';
import Page404 from '@/views/404';
import Test from '@/views/Test';

import Login from '@/views/Login';
import Registration from '@/views/Registration';
import Profile from '@/views/Profile';
import AdminPanel from '@/views/admin-panel/AdminPanel.vue';
import AdminPanelBanners from '@/components/admin-panel/AdminPanelBanners.vue';
import AdminPanelServices from '@/components/admin-panel/AdminPanelServices.vue';
import CreateService from '@/components/admin-panel/CreateService.vue';
import AdminPanelBaskets from '@/components/admin-panel/AdminPanelBaskets.vue';
import AdminPanelNews from '@/components/admin-panel/AdminPanelNews.vue';
import AdminPanelEducation from '@/components/admin-panel/AdminPanelEducation.vue';

const Managers = () => import('@/views/managers/Managers');
const Manager = () => import('@/views/managers/_id');

const Clients = () => import('@/views/clients/Clients');
const Client = () => import('@/views/clients/_id');
const ClientPromocodesPage = () => import('@/views/clients/ClientPromocodesPage');
const ClientCalcCompliancePage = () => import('@/views/clients/ClientCalcCompliancePage');

const Candidates = () => import('@/views/candidates/Candidates');
const Candidate = () => import('@/views/candidates/_id');
const CandidateReportsPage = () => import('@/views/candidates/CandidateReportsPage');

const Partners = () => import('@/views/partners/Partners');
const Partner = () => import('@/views/partners/_id');
const PartnerPromocodesPage = () => import('@/views/partners/PartnerPromocodesPage');

const Profgrams = () => import('@/views/profgrams');
const Analitics = () => import('@/views/analytics');
const Admins = () => import('@/views/admins/Admins');
const Admin = () => import('@/views/admins/_id');
const Services = () => import('@/views/Services');
const Support = () => import('@/views/Support');
const Access = () => import('@/views/Access');
const AIPage = () => import('@/views/ai');
const AIHRProjectEdit = () => import('@/views/ai/hrProjectEdit.vue');
const AIHRProjectView = () => import('@/views/ai/hrProjectView.vue');
// const FullTest = () => import('@/views/FullTest');
// const ShortTest = () => import('@/views/ShortTest');
// const PsychoType = () => import('@/views/psycho/PsychoType');
const Reports = () => import('@/views/Reports');

const ResetPassword = () => import('@/views/ResetPassword');
const UpdatePassword = () => import('@/views/UpdatePassword');

const CreateByRef = () => import('@/views/psycho/CreateByRef');

const RefProgram = () => import('@/views/refprogram/RefProgram');
const RefLinks = () => import('@/views/refprogram/RefLinks');
const Promocodes = () => import('@/views/Promocodes');
const CalcCompliancePage = () => import('@/views/CalcCompliancePage');

const EditTests = () => import('@/views/editTests/index.vue');

const listServices = () => import('@/views/listServices/listServices.vue');
const serviceDetail = () => import('@/views/listServices/_id.vue');
const reportSample = () => import('@/views/listServices/reportSample/_id.vue');

const basket = () => import('@/views/Basket/Basket.vue');

const myServices = () => import('@/views/myServices/MyServices.vue');

const Materials = () => import('@/views/trainingMaterials/Materials.vue');
const DetailMaterial = () => import('@/views/trainingMaterials/DetailMaterial.vue');

const Diagnostic = () => import('@/views/diagnostic/Diagnostic.vue');
const AdminDiagnostic = () => import('@/views/diagnostic/AdminDiagnostic.vue');
const DiagnosticDetail = () => import('@/views/diagnostic/DiagnosticDetail.vue');

const BookingCalendar = () => import('@/views/calendar/Calendar.vue');
const PublicBooking = () => import('@/views/calendar/PublicBooking.vue');
const CancelAppointment = () => import('@/views/calendar/CancelAppointment.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    // redirect: '/welcome/index.html',
    redirect: { name: 'login' },
  },
  {
    path: '/',
    component: AuthLayout,
    name: 'auth-layout',
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { onlyPublic: true },
      },
      {
        path: '/registration',
        name: 'registration',
        component: Registration,
        meta: { onlyPublic: true },
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPassword,
        meta: { onlyPublic: true },
      },
      {
        path: '/update-password',
        name: 'update-password',
        component: UpdatePassword,
        meta: { onlyPublic: true },
      },
      {
        path: '/test/:token',
        name: 'test',
        component: Test,
      },
      {
        path: '/ref/:ref',
        name: 'reflink',
        component: CreateByRef,
      },
      {
        // Путь не финализирован бэком — см. audit/calendar-api-reference.md, «Вопросы к бэку».
        path: '/booking',
        name: 'public-booking',
        component: PublicBooking,
      },
      {
        // Путь и формат (#token=... во фрагменте, не query) — как в письме от бэка,
        // тоже пока не финализирован официально, см. audit/calendar-api-reference.md.
        path: '/calendar/appointments/cancel',
        name: 'cancel-appointment',
        component: CancelAppointment,
      },
    ],
  },
  {
    path: '/',
    name: 'dashboard-layout',
    component: DashboardLayout,
    meta: { allowed: [ADMIN, MANAGER, CANDIDATE] },
    children: [
      {
        path: 'profile',
        name: 'profile',
        component: Profile,
        meta: { allowed: [MANAGER, ADMIN], permission: 'bookmark_personal_cabinet' },
      },
      {
        path: 'managers',
        name: 'managers',
        component: Managers,
        meta: { allowed: [MANAGER, ADMIN], permission: ['bookmark_managers'] },
      },
      {
        path: 'managers/:id',
        name: 'managers-id',
        component: Manager,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_manager'] },
      },

      {
        path: 'clients',
        name: 'clients',
        component: Clients,
        meta: { allowed: [MANAGER, ADMIN], permission: ['bookmark_corporate_clients'] },
      },
      {
        path: 'clients/:id',
        name: 'clients-id',
        component: Client,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_corpclient'] },
      },
      {
        path: 'clients/:id/promocodes',
        name: 'clients-id-promocodes',
        component: ClientPromocodesPage,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_corpclient'] },
      },
      {
        path: 'clients/:id/compliance',
        name: 'clients-id-compliance',
        component: ClientCalcCompliancePage,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_corpclient'] },
      },

      {
        path: 'candidates',
        name: 'candidates',
        component: Candidates,
        meta: { allowed: [ADMIN, MANAGER], permission: ['bookmark_candidates'] },
      },
      {
        path: 'candidates/:id',
        name: 'candidates-id',
        component: Candidate,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_candidate'] },
      },
      {
        path: 'candidates/:id/reports/:reportType',
        name: 'candidates-id-report',
        component: CandidateReportsPage,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_candidate'] },
      },

      {
        path: 'profgrams',
        name: 'profgrams',
        component: Profgrams,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_positions_profiles'] },
      },

      {
        path: 'partners',
        name: 'partners',
        component: Partners,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_partners'] },
      },
      {
        path: 'partners/:id',
        name: 'partners-id',
        component: Partner,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_partner'] },
      },
      {
        path: 'partners/:id/promocodes',
        name: 'partners-id-promocodes',
        component: PartnerPromocodesPage,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_partner'] },
      },

      {
        path: 'admins',
        name: 'admins',
        component: Admins,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_administrators'] },
      },
      {
        path: 'admins/:id',
        name: 'admins-id',
        component: Admin,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_administrators'] },
      },
      {
        path: 'services',
        name: 'services',
        component: Services,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_services'] },
      },
      {
        path: 'support',
        name: 'support',
        component: Support,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_support'] },
      },
      {
        path: 'access',
        name: 'access',
        component: Access,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_accesscontrol'] },
      },
      // {
      //   path: '/tests',
      //   name: 'tests',
      //   component: FullTest,
      // },
      {
        path: '/edit-tests',
        name: 'edit-tests',
        component: EditTests,
        meta: { permission: 'view_instrumentset' },
      },
      {
        path: 'refprogram',
        name: 'refprogram',
        component: RefProgram,
        meta: { allowed: [MANAGER, ADMIN], permission: 'bookmark_personal_cabinet' },
      },
      {
        path: 'reflinks',
        name: 'reflinks',
        component: RefLinks,
        meta: { allowed: [MANAGER, ADMIN], permission: 'bookmark_personal_cabinet' },
      },
      {
        path: 'ai',
        name: 'ai',
        component: AIPage,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_ai_expert'] },
      },
      {
        path: 'ai/hrproject-edit/:id',
        name: 'ai-hrproject-edit',
        component: AIHRProjectEdit,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_ai_expert'] },
      },
      {
        path: 'ai/hrproject-view/:id',
        name: 'ai-hrproject-view',
        component: AIHRProjectView,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_ai_expert'] },
      },
      {
        path: 'analitics',
        name: 'analitics',
        component: Analitics,
        meta: { allowed: [MANAGER, ADMIN], permission: 'bookmark_personal_cabinet' },
      },
      {
        path: 'promocodes',
        name: 'promocodes',
        component: Promocodes,
        meta: { allowed: [MANAGER, ADMIN], permission: 'bookmark_personal_cabinet' },
      },
      {
        path: 'compliance',
        name: 'compliance',
        component: CalcCompliancePage,
        meta: { allowed: [MANAGER, ADMIN], permission: 'bookmark_personal_cabinet' },
      },
      {
        path: 'reports',
        name: 'reports',
        component: Reports,
        // meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_candidate'] },
        meta: { allowed: [MANAGER, ADMIN], permission: 'bookmark_personal_cabinet' },
      },
      {
        path: 'reports/:reportType',
        name: 'reports-id',
        component: Reports,
        meta: { allowed: [MANAGER, ADMIN], permission: 'bookmark_personal_cabinet' },
        // meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_candidate'] },
      },
      {
        path: 'admin-panel',
        name: 'admin-panel',
        component: AdminPanel,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_admin_panel'] },
      },
      {
        path: 'admin-panel/banners',
        name: 'banners',
        component: AdminPanelBanners,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_admin_panel'] },
      },
      {
        path: 'admin-panel/services',
        name: 'admin-services',
        component: AdminPanelServices,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_admin_panel'] },
      },
      {
        path: 'admin-panel/services/add',
        name: 'add-services',
        component: CreateService,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_admin_panel'] },
      },
      {
        path: 'admin-panel/services/update/:id',
        name: 'update-service',
        component: CreateService,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_admin_panel'] },
      },
      {
        path: 'admin-panel/viewBaskets',
        name: 'viewBaskets',
        component: AdminPanelBaskets,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_admin_panel'] },
      },
      {
        path: 'admin-panel/news',
        name: 'news',
        component: AdminPanelNews,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_admin_panel'] },
      },
      {
        path: 'admin-panel/educationMaterials',
        name: 'educationMaterials',
        component: AdminPanelEducation,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_admin_panel'] },
      },
      {
        path: 'list-services',
        name: 'list-services',
        component: listServices,
        meta: { allowed: [ADMIN] },
      },
      {
        path: 'list-services/:id',
        name: 'serviceDetail',
        component: serviceDetail,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE] },
      },
      {
        path: 'list-services/reportSample/:id',
        name: 'reportSample',
        component: reportSample,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['view_manager'] },
      },
      {
        path: 'basket',
        name: 'basket',
        component: basket,
      },
      {
        path: 'my-services',
        name: 'my-services',
        component: myServices,
      },
      {
        path: 'training-materials',
        name: 'training-materials',
        component: Materials,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_training_materials'] }
      },
      {
        path: 'training-materials/:educationId',
        name: 'training-materials',
        component: DetailMaterial,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['can_view_training_materials'] }
      },
      {
        path: 'diagnostic',
        name: 'diagnostic',
        component: Diagnostic,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_diagnostic'] }
      },
      {
        path: 'diagnostic/admin',
        name: 'admin-diagnostic',
        component: AdminDiagnostic,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_diagnostic'] }
      },
      {
        path: 'diagnostic/:id',
        name: 'diagnostic-detail',
        component: DiagnosticDetail,
        meta: { allowed: [ADMIN, MANAGER, CANDIDATE], permission: ['bookmark_diagnostic'] }
      },
      {
        path: 'booking-calendar',
        name: 'booking-calendar',
        component: BookingCalendar,
        meta: { allowed: [ADMIN, MANAGER], permission: ['bookmark_booking_calendar'] }
      },
      { path: '/noaccess', name: 'noaccess', component: NoAccess, },
      { path: '*', name: '404', component: Page404, },
    ],
  },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = store.getters['auth/token'];
  let loggedIn = store.getters['auth/loggedIn'];

  //  console.log(token, loggedIn, to);

  if (!loggedIn) {
    if (token) {
      try {
        await store.dispatch('auth/loadMe');
        loggedIn = store.getters['auth/loggedIn'];
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          return next({ name: 'login' });
        }
        next(false);
        // next(false) forces the URL back to the previous route (here, the
        // default '/'), so restore the address bar to the page the user was
        // actually trying to open — otherwise a manual refresh sends them home.
        if (window.location.pathname + window.location.search !== to.fullPath) {
          window.history.replaceState(window.history.state, '', to.fullPath);
        }
        return;
      } finally {
        store.commit('auth/setInitialized');
      }
    }
  }

  const isPublicRoute = to.matched.some((r) => r.name === 'auth-layout')
    || ['noaccess', '404'].includes(to.name);

  if (!loggedIn) {
    if (!isPublicRoute) return next({ name: 'login' });
    return next();
  }

  if (to.meta?.onlyPublic || to.path === '') return next({ name: 'profile' });

  if (!to.meta.permission || store.getters['auth/isAllowed'](to.meta.permission)) {
    return next();
  }
  // console.log(to);
  return next({ name: 'noaccess' });
  // return next({ name: 'dashboard-layout-root' });
});

export default router;
